export default __webpack_public_path__ + "6eac5293889b6d5a7643dd4c5c324faa.png";